<template>
  <div class="hero">
    <img src="@/assets/img/header.jpg" alt="yurtlar burada" class="hero-bg desktopHero">
    <img src="@/assets/img/bg-mobile.jpg" alt="yurtlar burada" class="hero-bg mobileHero">
    <!--<img src="@/assets/img/mobile-hero.jpg" alt="yurtlar burada" class="hero-bg mobile">-->
    <container>
      <div class="hero__wrp">
        <h1 class="hero__title" v-if="settings">
          {{ settings.setting.home_title }}
        </h1>
        <p class="hero__txt" v-if="settings">
          {{ settings.setting.home_slogan }}
        </p>
        <HeroSearch />
        <HeroSlider />
      </div>
    </container>
  </div>
</template>

<script>
import HeroSearch from '@/components/Home/HeroSearch.vue'
import HeroSlider from '@/components/Home/HeroSlider.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'home-hero',
  components: {
    HeroSearch,
    HeroSlider
  },
  computed: {
    ...mapGetters(['settings'])
  }
}
</script>

<style lang="scss" scoped>
  .hero {
    background: #27344e;
    padding-top: 94px;
  }
  @import "../../assets/scss/components/hero";
</style>
